import { ReactNode } from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import { Contact } from 'flow/types/Contact';
import { TypedMap } from 'flow/types/TypedMap';
import { extractName } from 'flow/utils';

interface NameFieldProps {
    contact: TypedMap<Contact>;
    fuzzyParsedText?: string;
    icon?: ReactNode;
    contextMenuIsActive?: boolean;
}

const NameField = ({
    contact,
    fuzzyParsedText,
    icon,
    contextMenuIsActive = false,
}: NameFieldProps) => {
    const { i18next } = useAppContext();

    return (
        <div className="m-auto flex w-full flex-row justify-between">
            <div className="overflow-hidden text-base/5 text-ellipsis text-gray-800">
                {fuzzyParsedText ||
                    extractName(contact, i18next.t('status.unknown'))}
            </div>
            {icon && !contextMenuIsActive && (
                <div className="group-focus-visible-within:hidden flex size-5 items-center justify-center rounded-sm bg-gray-200 text-xs text-gray-600 group-hover:hidden">
                    {icon}
                </div>
            )}
        </div>
    );
};

export default NameField;
